export const LOCAL_STORAGE_KEYS = {
  TOKEN: "token",
  REFRESH_TOKEN: "refresh_token"
};
